<script lang="ts">
  import * as _ from "lodash";
  import ProductImage from "@shared/svelte/Components/ProductImage.svelte";
  import type { ProductChooserOptionsType } from "@shared/types/Filters";

  export let productLines = [];
  export let searchProductLines: any;
  export let onSelectProduct: any;
  export let productChooserOptions: ProductChooserOptionsType = {};
  export let selectMultipleChoices: any;
  export let maxProductsSelected: boolean;
  export let numSelectedFilters: number;
  export let showFiltersInMobile: boolean;
  export let loading: boolean;
  let searchValue: string;

  function toggleMobileFiltersView() {
    showFiltersInMobile = true;
  }

  function categoryDisplay(productLine: any) {
    let result = "" + _.get(productLine, "manufacturer.name");
    if (_.get(productLine, "manufacturer.name")) {
      result += " | ";
    }
    let val = productLine.subcategory_name;
    if (val == "Default") {
      val = productLine.category_name;
    }
    if (val == "Other") {
      val = "";
    }
    if (val) {
      result += val;
    }
    return result;
  }

  function onSelectProductWrapper(plid: any) {
    if (!productChooserOptions.selectMultiple) {
      return onSelectProduct(plid);
    } else {
      return onSelectProductMultiple(plid);
    }
  }

  const debounceSearch = _.debounce(search, 400);
  function search() {
    if (searchValue.length != 1) {
      searchProductLines(searchValue);
    }
  }

  function onSelectProductMultiple(plid: any) {
    let maxSelected = maxProductsSelected && !selectMultipleChoices[plid];
    if (productChooserOptions.selectMultiple && !maxSelected) {
      if (selectMultipleChoices[plid]) {
        selectMultipleChoices[plid] = false;
        selectMultipleChoices = selectMultipleChoices;
      } else {
        selectMultipleChoices[plid] = true;
        selectMultipleChoices = selectMultipleChoices;
      }
    }
  }
  $: selectMultipleChoices;

</script>

<form class="fizz-flex-row-responsive fizz-stack-32">
  <input
    type="text"
    name="search"
    id="catalog-search-input"
    data-testid="catalog-search-input"
    placeholder="Search your catalog"
    class="fizz-input-search fizz-flex-item"
    bind:value={searchValue}
    on:input={debounceSearch}
  />
  <button
    class="fizz-hide-on-large fizz-button fizz-stack-16 fizz-sidebar-toggle"
    data-parent="featuredProduct"
    on:click|preventDefault={toggleMobileFiltersView}
  >
    Filters {#if numSelectedFilters}({numSelectedFilters}){/if}
  </button>
  {#if loading}
    <span class="fizz-text-medium loading" style="min-width: 150px;">Loading...</span>
  {:else if productLines}
    <span class="fizz-text-medium" style="min-width: 150px;"
      >Showing {productLines.length} Product{#if productLines.length != 1}s{/if}</span
    >
  {/if}
</form>
<ul class="fizz-flow-24 fizz-stack-16" id="product-search-results">
  {#each productLines as productLine}
    <li
      class="fizz-flex-row fizz-highlight-on-hover"
      id="product-line-{productLine.id}"
      style="cursor: pointer;"
      on:click={() => onSelectProductWrapper(productLine.id)}
    >
      <div class="fizz-frame-square" style="--size: 55px;">
        <ProductImage
          product={{ cloudinary_image_url: _.get(productLine, "cloudinary_image_url") }}
          fizz={true}
        />
      </div>
      <p class="fizz-flex-item">
        <strong>{productLine.name}</strong>
        <br />
        <span class="fizz-text-subdued fizz-text-medium">{categoryDisplay(productLine)}</span>
      </p>
      {#if productChooserOptions.selectMultiple}
        <input
          class="fizz-checkbox-large cursor-pointer"
          id="select-product-line-{productLine.id}"
          data-testid="select-product-line-{productLine.id}"
          type="checkbox"
          disabled={maxProductsSelected && !selectMultipleChoices[productLine.id]}
          checked={selectMultipleChoices[productLine.id]}
        />
      {/if}
    </li>
  {/each}
</ul>
